import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/authService/auth.service';
import { ClientService } from 'src/app/core/services/clientService/client.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  appUser$: Observable<any>;
data$: Observable<any[]>;
  links = [
    {
      name: 'Hauptseite',
      url: '/client/search'
    },
    {
      name: 'Kunden',
      url: '/client/list'
    },
    {
      name: 'Kunde hinzufügen',
      url: '/client/new'
    },
    {
      name: 'Besuche',
      url: '/client/visits'
    }
  ];
  constructor(private authService: AuthService, private clientService: ClientService) {}

  ngOnInit() {
    console.log('ngOnInit called');
    this.appUser$ = this.authService.currentUserValue;
    this.data$ = this.clientService.getStats();
  }

  logout() {
    return this.authService.logout();
  }
  refresh(){
    console.log('refresh called');
    this.data$ = this.clientService.getStats();
  }

  
}
